import styled from '@emotion/styled/macro';
import {
  SvgIcon,
  SvgNames,
  Typography,
} from '@sunrun/experience-ui-components';
import { useRef, useState } from 'react';
// eslint-disable-next-line import/no-restricted-paths
import { ActionNeededWidget } from 'components/organisms/ActionNeededWidget';
import {
  PipelineColumnExpandButton,
  PipelineColumnHeader,
  PipelineColumnShell,
  // eslint-disable-next-line import/no-restricted-paths
} from 'components/organisms/PipelineColumn';
import { navigateToCustomerProfile } from 'helpers/listViewHelpers';

type ActionNeededColumnProps = {
  allowExpand: boolean;
};

const ActionNeededColumn = ({ allowExpand }: ActionNeededColumnProps) => {
  const [expanded, setExpanded] = useState(false);
  const columnRef = useRef<HTMLDivElement>(null);

  return (
    <Column
      expanded={expanded}
      ref={columnRef}
      data-testid="sales-ex-dashboard--pipeline-column--action-needed">
      <PipelineColumnHeader>
        <Typography>Action needed</Typography>
        {allowExpand && (
          <PipelineColumnExpandButton
            aria-label={expanded ? 'Collapse column' : 'Expand column'}
            iconMiddle={
              <SvgIcon
                name={
                  expanded ? SvgNames.ArrowsInSimple : SvgNames.ArrowsOutSimple
                }
              />
            }
            color="tertiary"
            onClick={() => {
              setExpanded((value) => !value);
              columnRef.current?.scrollIntoView({
                block: 'nearest',
                inline: 'start',
              });
            }}
          />
        )}
      </PipelineColumnHeader>
      <ActionNeededWidget
        onTaskClick={navigateToCustomerProfile}
        onlyRecentTasks={false}
        isExpanded={expanded}
        embeddedInColumn
      />
    </Column>
  );
};

const Column = styled(PipelineColumnShell)`
  overflow-x: hidden;
`;

export { ActionNeededColumn };
